import React, { useState, useEffect } from 'react';
import Svg, { Path, Circle } from 'react-native-svg';
// import { useGetUnreadCountQuery } from '../../store/api/UserApi';
import { useSelector } from 'react-redux';

function NotificationsIcon({ width = 24, height = 24, color = 'black' }) {
  const unreadCount = useSelector((state) => state.unreadCount);
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
        fill={color}
      />
      {unreadCount > 0 && <Circle cx="18" cy="6" r="6" fill="red" />}
    </Svg>
  );
}

export default NotificationsIcon;
